/**
 * Task 11 - closet sections ("families"): the way you'd actually label the parts of a closet.
 * All · Shirts · Sweaters · Jackets · Pants · Shorts · Dresses & Skirts · Suits · Shoes · Accessories.
 * Each family is a set of taxonomy subcategories;
 */
export const FAMILIES = [
  { key: "shirts", label: "Shirts", subs: ["tshirt", "polo", "dress_shirt", "casual_shirt", "tank", "other_top"] },
  { key: "sweaters", label: "Sweaters", subs: ["sweater", "hoodie", "sweatshirt"] },
  { key: "jackets", label: "Jackets", subs: ["suit_jacket", "jacket", "coat", "puffer", "rain_jacket", "vest", "other_outerwear"] },
  { key: "pants", label: "Pants", subs: ["jeans", "pants", "sweatpants", "snow_pants", "rain_pants", "other_bottom"] },
  { key: "shorts", label: "Shorts", subs: ["shorts", "swimwear"] },
  { key: "dresses", label: "Dresses & Skirts", subs: ["dress", "skirt", "jumpsuit"] },
  { key: "suits", label: "Suits", subs: ["suit"] },
  { key: "shoes", label: "Shoes", subs: ["sneakers", "dress_shoes", "boots", "sandals", "slippers", "other_shoes"] },
  { key: "accessories", label: "Accessories", subs: ["hat", "sunglasses", "belt", "bag", "scarf", "gloves", "watch", "jewelry", "tie", "socks", "other_accessory"] },
  { key: "other", label: "Other", subs: ["other"] },
];

const SUB_TO_FAMILY = Object.fromEntries(FAMILIES.flatMap((f) => f.subs.map((s) => [s, f.key])));
const GROUP_FALLBACK = { top: "shirts", outerwear: "jackets", bottom: "pants", dress: "dresses", shoes: "shoes", accessory: "accessories" };

export const familyOf = (item) => SUB_TO_FAMILY[item?.subcategory] || GROUP_FALLBACK[item?.category] || "other";
export const familyByKey = (key) => FAMILIES.find((f) => f.key === key);

/** Does `item` belong to section `key`? Sections: all | forsale | sold | g:<group> | <family key>. */
export const inSection = (item, key) => {
  if (!key || key === "all") return true;
  if (key === "sold") return item.listing_type === "sold";
  if (key === "forsale") return ["sell", "swap", "both"].includes(item.listing_type);
  if (key.startsWith("g:")) return item.category === key.slice(2);
  return familyOf(item) === key;
};

export const sectionLabel = (key, tax) => {
  if (!key || key === "all") return "Everything";
  if (key === "sold") return "Sold";
  if (key === "forsale") return "For sale";
  if (key.startsWith("g:")) return (tax?.groups || []).find((g) => g.key === key.slice(2))?.label || key.slice(2);
  return familyByKey(key)?.label || key;
};



